import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom'
import { Pencil, TOOL_PENCIL, Line, TOOL_LINE, Ellipse, TOOL_ELLIPSE, Rectangle, TOOL_RECTANGLE, Arrow, TOOL_ARROW } from './tools'
// import CanvasUndo from "undo-canvas"
export const toolsMap = {
  [TOOL_PENCIL]: Pencil,
  [TOOL_LINE]: Line,
  [TOOL_RECTANGLE]: Rectangle,
  [TOOL_ELLIPSE]: Ellipse,
  [TOOL_ARROW]: Arrow,
};

export default class SketchPad extends Component {

  tool = null;
  interval = null;

  // static propTypes = {
  //   width: PropTypes.number,
  //   height: PropTypes.number,
  //   items: PropTypes.array.isRequired,
  //   animate: PropTypes.bool,
  //   canvasClassName: PropTypes.string,
  //   color: PropTypes.string,
  //   fillColor: PropTypes.string,
  //   size: PropTypes.number,
  //   tool: PropTypes.string,
  //   toolsMap: PropTypes.object,
  //   onItemStart: PropTypes.func, // function(stroke:Stroke) { ... }
  //   onEveryItemChange: PropTypes.func, // function(idStroke:string, x:number, y:number) { ... }
  //   onDebouncedItemChange: PropTypes.func, // function(idStroke, points:Point[]) { ... }
  //   onCompleteItem: PropTypes.func, // function(stroke:Stroke) { ... }
  //   debounceTime: PropTypes.number,
  // };

  static defaultProps = {
    width: 500,
    height: 500,
    color: '#000',
    size: 2,
    fillColor: '',
    canvasClassName: 'canvas',
    debounceTime: 1000,
    animate: false,
    tool: TOOL_PENCIL,
    toolsMap
  };

  constructor(props) {
    super(props);
    this.initTool = this.initTool.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onDebouncedMove = this.onDebouncedMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
  }

  componentDidMount() {
    this.canvas = findDOMNode(this.canvasRef);
    this.ctx = this.canvas.getContext('2d');
    // CanvasUndo.enableUndo(this.ctx)
    this.props.getContext(this.ctx)

    let canvas = document.getElementsByTagName('canvas')[0];
    setTimeout(() => {
      canvas.width = window.innerWidth - 300;
      // console.log({ width: document.getElementById("containerForWhiteboard")?.clientWidth, heigh: document.getElementById("containerForWhiteboard")?.clientHeight })
      canvas.height = document.getElementById("containerForWhiteboard")?.clientHeight;
      this.initTool(this.props.tool);
    }, 2000);

    window.addEventListener("resize", (e) => {
      // console.log("WROKINGGG",e.currentTarget.innerWidth)
      let canvas2 = document.getElementsByTagName('canvas')[0];
      canvas2.width = e.currentTarget.innerWidth - 300;
      // console.log({ width: e.currentTarget.innerWidth - 300, heigh: document.getElementById("containerForWhiteboard")?.clientHeight },"working")
      canvas2.height = document.getElementById("containerForWhiteboard")?.clientHeight;
      this.initTool(this.props.tool);
      this.props.refresh()
    })
  }


  componentWillReceiveProps({ tool, items }) {
    // console.log(items.filter(item => this.props.items.indexOf(item) === -1), "FROM Sketchpad")
    items
      // .filter(item => this.props.items.indexOf(item) === -1)
      .forEach(item => {
        if(!item) return
        // console.log("ITEM", item)
        this.initTool(item.tool);
        this.tool.draw(item, this.props.animate);
      });
    this.initTool(tool);
  }

  initTool(tool) {
    this.tool = this.props.toolsMap[tool](this.ctx);
  }

  onMouseDown(e) {
    this.props.setControlBarOff()
    const data = this.tool.onMouseDown(...this.getCursorPosition(e), this.props.color, this.props.size, this.props.fillColor);
    data && data[0] && this.props.onItemStart && this.props.onItemStart.apply(null, data);
    if (this.props.onDebouncedItemChange) {
      this.interval = setInterval(this.onDebouncedMove, this.props.debounceTime);
    }
  }

  onDebouncedMove() {
    if (typeof this.tool.onDebouncedMouseMove == 'function' && this.props.onDebouncedItemChange) {
      this.props.onDebouncedItemChange.apply(null, this.tool.onDebouncedMouseMove());
    }
  }

  onMouseMove(e) {
    const data = this.tool.onMouseMove(...this.getCursorPosition(e));
    data && data[0] && this.props.onEveryItemChange && this.props.onEveryItemChange.apply(null, data);
  }

  onMouseUp(e) {
    this.props.setControlBarOn()
    const data = this.tool.onMouseUp(...this.getCursorPosition(e));
    data && data[0] && this.props.onCompleteItem && this.props.onCompleteItem.apply(null, data);
    if (this.props.onDebouncedItemChange) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  getCursorPosition(e) {
    const { top, left } = this.canvas.getBoundingClientRect();
    return [
      e.clientX - left,
      e.clientY - top
    ];
  }

  render() {
    const { width, height, canvasClassName } = this.props;
    return (
      <canvas
        ref={(canvas) => { this.canvasRef = canvas; }}
        className={canvasClassName}
        onMouseDown={this.onMouseDown}
        onMouseMove={this.onMouseMove}
        onMouseOut={this.onMouseUp}
        onMouseUp={this.onMouseUp}

      // width={document.getElementById("containerForWhiteboard")?.clientWidth}
      // height={document.getElementById("containerForWhiteboard")?.clientHeight}
      // width={2000}
      // height={2000}
      />
    )
  }
}
